import { render, staticRenderFns } from "./FormClientDetails.vue?vue&type=template&id=4e23482e&scoped=true"
import script from "./FormClientDetails.vue?vue&type=script&lang=js"
export * from "./FormClientDetails.vue?vue&type=script&lang=js"
import style0 from "./FormClientDetails.vue?vue&type=style&index=0&id=4e23482e&prod&scoped=true&lang=scss"
import style1 from "./FormClientDetails.vue?vue&type=style&index=1&id=4e23482e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e23482e",
  null
  
)

export default component.exports